import React from "react";

/**
 * i-Qualify Logo Component (The Zen Wave)
 * Reusable SVG logo with text for the i-Qualify brand.
 *
 * @param {object} props
 * @param {boolean} props.showText - Whether to show the "I-Qualify" text alongside the icon
 * @param {string}  props.size - "sm" | "md" | "lg" | "xl" — controls icon dimensions
 * @param {string}  props.layout - "horizontal" | "vertical" — icon and text arrangement
 * @param {string}  props.className - Additional CSS classes
 */
const sizes = {
  sm: { icon: "w-10 h-10", text: "text-xl", dash: "text-lg" },
  md: { icon: "w-14 h-14", text: "text-2xl", dash: "text-xl" },
  lg: { icon: "w-24 h-24", text: "text-4xl", dash: "text-3xl" },
  xl: { icon: "w-36 h-36", text: "text-6xl", dash: "text-5xl" },
};

export default function IQualifyLogo({ showText = true, size = "md", layout = "horizontal", className = "" }) {
  const s = sizes[size] || sizes.md;
  const isVertical = layout === "vertical";

  return (
    <div className={`flex ${isVertical ? "flex-col items-center gap-3" : "items-center gap-3"} ${className}`}>
      {/* The Zen Wave Icon */}
      <div className={`${s.icon} flex-shrink-0`}>
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <defs>
            <linearGradient id="iq-grad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#1e3a8a" />
              <stop offset="100%" stopColor="#14b8a6" />
            </linearGradient>
          </defs>
          {/* Chat bubble frame */}
          <path
            d="M 50 10 A 40 40 0 1 0 85 70 L 90 90 L 70 85 A 40 40 0 0 0 50 10 Z"
            fill="none"
            stroke="url(#iq-grad)"
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {/* Zen wave inside */}
          <path
            d="M 35 30 Q 60 40 40 60 T 65 75"
            fill="none"
            stroke="url(#iq-grad)"
            strokeWidth="6"
            strokeLinecap="round"
          />
        </svg>
      </div>

      {/* Wordmark */}
      {showText && (
        <span className={`font-bold tracking-tight ${s.text} whitespace-nowrap`} style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}>
          <span className="text-gray-400 font-light">I</span>
          <span className={`text-blue-900 ${s.dash}`}>-</span>
          <span className="text-blue-900">Qualify</span>
        </span>
      )}
    </div>
  );
}
